<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="6" width="7" height="11" stroke="#999999" stroke-width="1.25" stroke-linejoin="round"/>
    <path d="M8 6V3H15V14H12" stroke="#999999" stroke-width="1.25" stroke-linejoin="round"/>
  </svg>
</template>